import { Rive } from '@klv/atoms/rive';
import ImageLink from '@klv/molecules/image-link';
import MixedMedia from '@klv/molecules/mixed-media';
import VideoModalTrigger from '@klv/molecules/video-modal-trigger';
import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from '../styles/hero.module.scss';

import type { IHeroMediaProps } from '../types';
import type { TColorVariant } from '@klv/shared/styles/types';

const HeroMedia = ({
  mediaType,
  image,
  imageLink,
  loopingVideo,
  hideMediaOnMobile,
  poster,
  rive,
  videoDuration,
  videoHeadline,
  videoUrl,
  videoPlayButtonColor,
  videoOverlayTitle,
  background,
  heroWithImage,
}: IHeroMediaProps) => {
  if (mediaType === 'image' && heroWithImage && image) {
    return (
      <div className={generateClassName([styles.mediaContainer, hideMediaOnMobile && styles.hideMediaOnMobile])}>
        <ImageLink backgroundColor={background as TColorVariant} image={image} imageLink={imageLink} loading='eager' />
      </div>
    );
  }

  if (mediaType === 'loopingVideo' && loopingVideo && poster?.gatsbyImage) {
    return (
      <div className={generateClassName([styles.mediaContainer, hideMediaOnMobile && styles.hideMediaOnMobile])}>
        <MixedMedia mixedMedia={{ mediaType: 'video', video: { loop: true, videoUrl: loopingVideo, poster } }} />
      </div>
    );
  }

  if (mediaType === 'rive' && rive?.riveFile) {
    return (
      <div className={generateClassName([styles.rive, hideMediaOnMobile && styles.hideMediaOnMobile])}>
        <Rive riveFile={rive.riveFile} aspectRatio={rive?.aspectRatio} flexibleLayout={rive?.flexibleLayout} riveText={rive?.riveText} height={rive.height} />
      </div>
    );
  }

  if (mediaType === 'videoModal' && heroWithImage && image) {
    return (
      <VideoModalTrigger
        videoDuration={videoDuration}
        modalHeadline={videoHeadline}
        videoUrl={videoUrl || ''}
        videoPlayButtonColor={videoPlayButtonColor}
        videoOverlayTitle={videoOverlayTitle}
      >
        <div className={generateClassName([styles.mediaContainer, hideMediaOnMobile && styles.hideMediaOnMobile])}>
          <ImageLink backgroundColor={background as TColorVariant} image={image} imageLink={imageLink} />
        </div>
      </VideoModalTrigger>
    );
  }

  return null;
};

export default HeroMedia;
